module.exports = 1;
module.exports = require("./circular");


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/circular-dependencies/circular.js
 ** module id = 1
 ** module chunks = 0
 **/